// src/modules/app-views/omnichannel/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const omnichannelInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters, // Opens OmnichannelParametersModal (WhatsApp tab)
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default omnichannelInitMenuButton;
